













import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, Watch} from 'vue-property-decorator'

import { DateTime } from 'luxon'
import { beginningOfCurrentDay, currentDate, currentDay } from '@/utils/date-util';

@Component({components: {}})
export default class FastDateGroupWings extends Vue {
  @PropSync('from') dateFrom!: string;
  @PropSync('to') dateTo!: string;
  @Prop({ default: 'datetime' }) readonly type!: string;

  private values = {
    today:{
      from: this.type==='date' ? currentDay() : beginningOfCurrentDay(),
      to: this.type==='date' ? currentDay() : currentDate(),
    },
    yesterday:{
      from: this.toISO(DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).plus({day: -1})),
      to: this.toISO(DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).plus({day: -1 + 1})),
    },
    week:{
      from: this.toISO(DateTime.local().set({hour:0,minute:0,second:0,millisecond:0}).plus({week:-1})),
      to: this.toISO(DateTime.local().set({minute:0})),
    },
    month:{
      from: this.toISO(DateTime.local().set({hour:0,minute:0,second:0,millisecond:0}).plus({month:-1})),
      to: this.toISO(DateTime.local().set({minute:0})),
    },
  }

  toISO(value:DateTime):string{
    switch (this.type) {
      case 'date':
        return value?.toFormat('yyyy-LL-dd') ?? ''
      default:
        return value.set({millisecond:0,second:0}).toISO({ includeOffset: false }) ?? ''
    }
  }

  checkCurrent(value:any):boolean{
    if(value.from == this.dateFrom) return true;
    return false
  }

  setDates(value:any):void{
    this.dateFrom = value.from;
    this.dateTo = value.to
  }
}
